import { Anexo } from "../../pages/suporte/types";

function baseApi(): string {
  const config = (window as unknown as { config?: { REACT_APP_BASE_URL?: string } })
    .config;
  return String(config?.REACT_APP_BASE_URL ?? "").replace(/\/+$/, "");
}

export function urlAnexo(url?: string): string {
  if (!url) return "";
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  return `${baseApi()}${url.startsWith("/") ? "" : "/"}${url}`;
}

export function comUrlAbsoluta(anexos: Anexo[]): Anexo[] {
  return anexos.map((anexo) => ({ ...anexo, url: urlAnexo(anexo.url) }));
}
